import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";
import { useLanguage } from "../../lib/i18n";

export const WeddingServices = () => {
  const { t } = useLanguage();
  const services = t("wservices.items");

  return (
    <section data-testid="wedding-services" className="tiled relative py-8 md:py-10 bg-[--bg]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-100px" }} className="max-w-2xl mb-14">
          <p className="font-mono uppercase tracking-[0.3em] text-[11px] text-[--gold] mb-6">{t("wservices.eyebrow")}</p>
          <h2 className="font-display font-light tracking-tight leading-[1.05] text-3xl sm:text-4xl md:text-5xl text-[--text]">
            {t("wservices.h2a")} <span className="italic text-[--gold]">{t("wservices.h2b")}</span>
          </h2>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <motion.div key={i} variants={fadeUp} custom={i % 3} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-50px" }} className="bg-[--surface] border border-white/10 rounded-2xl p-7">
              <h3 className="font-display text-xl text-[--text] mb-2">{s.title}</h3>
              <p className="text-[--text-2] text-sm leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
